import * as actions from "./actions";
import * as constants from "./constants";
import reducer from "./reducer";
import * as sagas from "./sagas";

import ViewMerchantsContainer from "./components/ViewMerchants";
import { currentMerchantName, currentMerchantId } from "./selectors";

import { Merchant } from "./constants";

export {
  ViewMerchantsContainer,
  reducer,
  constants,
  sagas,
  actions,
  currentMerchantName,
  currentMerchantId,
  Merchant
};

export default {
  constants,
  reducer,
  sagas,
  actions,
  ViewMerchantsContainer
};



// WEBPACK FOOTER //
// ./client/modules/Merchant/index.ts